import { render, staticRenderFns } from "./WeChatSendSection.vue?vue&type=template&id=560937ba&scoped=true&"
import script from "./WeChatSendSection.vue?vue&type=script&lang=js&"
export * from "./WeChatSendSection.vue?vue&type=script&lang=js&"
import style0 from "./WeChatSendSection.vue?vue&type=style&index=0&id=560937ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560937ba",
  null
  
)

export default component.exports